"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizeViewListItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const react_dnd_1 = require("react-dnd");
const table_customize_view_styles_1 = require("./table-customize-view.styles");
const AttributeTitle_1 = require("../../partials/AttributeTitle");
const table_columns_1 = require("../../../../../../common/table-columns");
const ItemType = 'COLUMN';
const CustomizeViewListItem = ({ item, index, isChecked, isDraggableDisabled, itemHeight, onCheck, onOrderChanged, }) => {
    const ref = (0, react_1.useRef)(null);
    const [{ isDragging }, dragRef] = (0, react_dnd_1.useDrag)(() => ({
        type: ItemType,
        item: { id: item.id, index },
        isDragging: (monitor) => item.id === monitor.getItem().id,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [item.id, index]);
    const [_, dropRef] = (0, react_dnd_1.useDrop)({
        accept: ItemType,
        hover: (draggedItem, monitor) => {
            var _a;
            const { id: targetId } = item;
            const dragIndex = draggedItem.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            onOrderChanged(draggedItem.id, targetId);
            draggedItem.index = hoverIndex;
        },
    });
    const handleCheck = (e) => {
        onCheck(item, e.target.checked);
    };
    const dataMeta = (0, react_1.useMemo)(() => (0, table_columns_1.parseColumnId)(item.id).dataMeta, [item]);
    dragRef(dropRef(ref));
    return (react_1.default.createElement(table_customize_view_styles_1.StyledListItem, { ref: ref, "$isDragging": isDragging, "$height": itemHeight }, react_1.default.createElement(material_1.IconButton, { disabled: isDraggableDisabled }, react_1.default.createElement(ui_components_1.Icon, { variant: "drag", color: "currentColor" })), react_1.default.createElement("label", null, react_1.default.createElement(table_customize_view_styles_1.StyledListItemCheckbox, { className: "checkbox", checked: isChecked, disabled: item.static, onChange: handleCheck }), react_1.default.createElement(AttributeTitle_1.AttributeTitle, { label: item.label, isAIEnriched: dataMeta.isAIEnriched }))));
};
exports.CustomizeViewListItem = CustomizeViewListItem;
exports.CustomizeViewListItem.displayName = 'CustomizeViewListItem';
